<template>
  <div class="main-content">
    <div v-if="loading" class="card">
      <div class="card-header">
        <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
      </div>
    </div>

    <div v-if="!loading">
      <div v-for="(orders, senderId) in orders" class="card">
        <div class="card-header">
          <h5>{{ senders[senderId].name }}</h5>
        </div>
        <div class="card-body">
          <CodOrdersList
            :ref="`orders_${senderId}`"
            :appointed="true"
            :disableEdit="true"
            :orders="orders"
          />
          <div class="card-footer text-right">
            <LoadingButton
              title="отметить доставленными"
              className="btn btn-outline-success btn-xs"
              :onClick="() => updateOrders(senderId, 'сloseOrders')"
              :loading="loadingSenderBtns[senderId]"
              :color="$constants.SUCCESS_COLOR"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api';
import CodOrdersList from "@/components/orders/list/CodOrdersList";
import LoadingButton from "@/components/buttons/LoadingButton"

export default {
  components: {CodOrdersList, LoadingButton},
  data() {
    return {
      loadingSenderBtns: {},
      loading: false,
      senders: {},
      orders: {}
    }
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    async updateOrders(senderId, action) {
      let selectedOrders = this.$refs['orders_' + senderId][0].selectedOrders;
      if (selectedOrders) {
        selectedOrders = Object.keys(selectedOrders).filter((k) => selectedOrders[k]);
      } else {
        toastr["warning"]("Выберите заявки");
        return;
      }
      const {data} = await api.post('/cod/updateOrders', {
        action,
        selectedOrders,
        senderId
      });
      if (data.success) {

      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }

    },
    async getOrders() {
      this.loading = true;
      const {data} = await api.index('/cod/sent');
      if (data.success) {
        this.orders = data.orders.reduce((acc, o) => {
          if (!acc[o.sender_id]) acc[o.sender_id] = [];
          acc[o.sender_id].push(o);
          return acc;
        }, {});
        this.senders = data.senders.reduce((acc, s) => {
          acc[s.id] = s;
          return acc;
        }, {});
      } else {
        toastr["warning"]("Ошибка сервера");
      }
      this.loading = false;

    }
  }
}
</script>
